import axiosClient from "./axiosClient";

export const getCallLogs = async (storeUuid) => {
    const response = await axiosClient.get(`/stores/${storeUuid}/call-logs`);
    return response.data.data;
};
